import CodePane from "./CodePane";
import DocumentationPane from "./DocumentationPane";
import ImagePane from "./ImagePane";

export { CodePane, DocumentationPane, ImagePane };
